<!-- <ul class="breadcrumb">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Inspection</li>
</ul> -->
<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Inspection</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/inspection/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/Inspection/edit?goveva=true&email=', 'method':'put', 'menu': 'Inspection'}"
          class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
  
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <!-- <form (document:click)="cesDate.close()"> -->
            <div class="row">
              <div class="col-md-4">
                <label>Name of the Person who Inspected Registers and Records</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <!-- <label>Nature of Documents Inspected </label> -->
                  <input type="text" class="form-control" name="nameOfInspectionList"
                    [(ngModel)]="nameOftheInspectedPerson">
                </div>
                <br>
              </div>
              <div class="col-md-3">
                <br>
                <!-- <label>Date of inspection</label> -->
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfInspectionList" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfInspectionList" ngbDatepicker
                    #cesDate="ngbDatepicker" (click)="cesDate.toggle();b.close()" [(ngModel)]="dateOfInspection">
                  <button class="input-group-addon" (click)="cesDate.toggle();b.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
  
  
              <div class="col-md-3">
                
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  To:&nbsp;
                  <input id="dateOfInspectionToList" class="form-control" [minDate]="futureToDateTo"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfInspectionToList" ngbDatepicker
                  #b="ngbDatepicker" (click)="b.toggle();cesDate.close()" [(ngModel)]="dateOfInspectionTo">
                <button class="input-group-addon" (click)="b.toggle();;cesDate.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
              <div class="form-group col-lg-2 col-md-2 col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2 doAdvSearch"
                    (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector"
                class="table table-hover compact cell-border nowrap stripe" id="inspectionalTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Date of Inspection</th>
                    <th style="display: none">Date of Inspection</th>
                    <th>Name of the Person who Inspected the registers and records</th>
                    <!-- <th>Status</th> -->
                    <th class="actionclass">Action
                    </th>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;">
                    <td>
                      <span style="display: none">{{director.dateOfInspection | date : "yMMdd"}}</span>
                      {{director.dateOfInspection | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{director.dateOfInspection | date : "dd-MM-y"}}
                    </td>
                    <td>
                      {{director.personwhoInspected}}
                    </td>
                    <!-- <td>
                                <span *ngIf="director.Status==true">Active</span>
                                <span *ngIf="director.Status==false">Inactive </span>
                              </td> -->
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" class="btn-sm btn btn-warning"  [appHasPermission]="{'Url': '/register/Inspection/edit?goveva=true&email=', 'method':'put', 'menu': 'Inspection'}"
                          (click)="loadInspectionDataById(director._id)">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger"  [appHasPermission]="{'Url': '/register/Inspection/edit?goveva=true&email=', 'method':'put', 'menu': 'Inspection'}" (click)="confirmDelete(director._id)">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Inspection details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteInspection()" data-dismiss="modal">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>